import { Component, EventEmitter, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ZonarUIMaterialModule } from '@zonar-ui/material';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule, ZonarUIMaterialModule, ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
  @Output() searchTerm = new EventEmitter<string>();

  onInput(text: string) {
    this.searchTerm.emit(text);
  }
}
